import React from "react";
import { createPortal } from "react-dom";
import SizeChartImg from "../assets/images/Sizechart.jpeg";

const SizeChartModal = ({ show, onClose }) => {
  if (!show) return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 3000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "28px",
          width: "720px",
          maxWidth: "100%",
          maxHeight: "88vh",
          overflowY: "auto",
          boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "18px",
          }}
        >
          <div>
            <h5 style={{ margin: 0, fontWeight: 800, color: "#1a1a1a" }}>
              📏 Size Chart
            </h5>
            <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#888" }}>
              Cuttingedge — Regular Fit
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "22px",
              lineHeight: 1,
              cursor: "pointer",
              color: "#888",
            }}
          >
            ×
          </button>
        </div>

        <img
          src={SizeChartImg}
          alt="Size Chart"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "8px",
            border: "1px solid #eee",
          }}
        />
      </div>
    </div>,
    document.body
  );
};

export default SizeChartModal;
